import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { random } from "lodash";

import { EditedLabelBlock } from "./EditedLabelBlock";

export const EditedLabelExtension = Node.create({
  name: "editedlabel",
  group: "inline",
  inline: true,
  selectable: false,
  atom: true,

  addAttributes: () => ({
    id: {
      default: random(),
    },
  }),

  parseHTML: () => [{ tag: "edited-label" }],
  renderHTML: ({ HTMLAttributes }) => [
    "edited-label",
    mergeAttributes(HTMLAttributes),
  ],
  addNodeView() {
    return ReactNodeViewRenderer(EditedLabelBlock);
  },
  addCommands() {
    return {
      addEditedLabelNode: () => props => {
        const { commands, editor } = props;
        if (editor.isEmpty) {
          return commands.insertContent({
            type: "paragraph",
            content: [{ type: "text", text: "" }, { type: "editedlabel" }],
          });
        }
        return commands.insertContent({
          type: "editedlabel",
        });
      },
    };
  },
});
